import type { Guid } from "@kiraah-shared/common";

export interface IMobileVoiceTicketSubmitTranscriptRequest {
  RawText: string;
  DemandUid?: Guid | null;
}

export interface IMobileVoiceTicketDemand {
  Uid: Guid;
  AuthorUid: Guid;
  RawText: string;
  Status: number;
  GeneratedTicketUid?: Guid | null;
}

export interface IMobileVoiceTicketGenerateResult {
  DemandUid: Guid;
  TicketUid: Guid;
  TicketLabel?: string | null;
}

export enum MobileVoiceTicketDemandStatus {
  Unknown = 0,
  TranscriptSaved = 1,
  TicketCreated = 2,
}
